export default __webpack_public_path__ + "static/media/emptyRemarks.5be25dca.svg";